<template>
  <div class="flex flex-column gap-2">
    <div class="flex p-float-label">
      <Calendar
        v-model="v$.value.$model"
        v-bind="$attrs"
        dateFormat="dd/mm/yy"
        showIcon
        inputId="date_range"
        selectionMode="range"
        class="flex-grow-1"
      />
      <label for="">{{ props.label }}</label>
    </div>
    <div class="flex">
      <small v-if="v$.value.$error" id="date_range-help" class="p-error">Date is required</small>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
const props = defineProps({
  modelValue: String | Date,
  label: {
    type: String,
    required: true
  },
  required: Boolean
})
let value = undefined
if (props.modelValue == undefined) {
  value = ref(new Date())
} else {
  value = ref(new Date(props.modelValue))
}

const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>
